import React, { useState } from "react"
import { Search as SearchIcon } from "styled-icons/boxicons-regular/Search"
import { navigate } from "gatsby"

import * as S from "./styled"
import Button from "../../components/Button"

const SearchBox = () => {
  const [query, setQuery] = useState("")
  const handleInput = event => {
    setQuery(event.target.value)
  }

  const handleSubmit = event => {
    event.preventDefault()

    navigate("/search/", { state: { query } })
  }

  return (
    <S.SearchBox>
      <h3>Busca: </h3>
      <S.SearchForm onSubmit={handleSubmit}>
        <S.SearchInput type="text" value={query} onChange={handleInput} />
        <Button
          background={props => props.theme.colors.highlight}
          color={props => props.theme.colors.primary}
          flat
          padding="0.5em 0.5em"
        >
          <SearchIcon size="1.5em" />
        </Button>
      </S.SearchForm>
    </S.SearchBox>
  )
}
export default SearchBox
